import {
    BeltContainer,
    createBeltContainer,
} from '@vfde-brix/ws10/belt-container';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { startAppListening } from '../app/listener';
import { selectHasError } from '../features/app/slice';
import { selectDevices } from '../features/app/selectors';

/**
 * Mount BeltContainers
 */
export const mountBeltContainers = (
    contentBeltContainerId: string,
    errorNotificationBeltContainerId: string,
) => {
    const contentBeltContainer = mountBeltContainer(contentBeltContainerId)!;
    const errorNotificationBeltContainer = mountBeltContainer(errorNotificationBeltContainerId);

    listenForUpdates(contentBeltContainer, errorNotificationBeltContainer);
};

const listenForUpdates = (
    contentBeltContainer: BeltContainer,
    errorNotificationBeltContainer: BeltContainer | null,
) => {
    startAppListening({
        predicate: (_action, currentState, previousState) =>
            (selectDevices(previousState).length === 0 && selectDevices(currentState).length !== 0)
            || (!selectHasError(previousState) && selectHasError(currentState)),
        effect: (_action, api) => {
            const state = api.getState();
            const hasError = selectHasError(state);

            contentBeltContainer.toggleContainer(hasError);
            errorNotificationBeltContainer?.toggleContainer(!hasError);
        },
    });
};

/**
 * Mounts a BeltContainer by ID
 */
const mountBeltContainer = (containerId: string): BeltContainer | null => {
    const container = document.getElementById(containerId);

    /* istanbul ignore if */
    if (!container) {
        return null;
    }

    return createBeltContainer(container, NO_PATTERN_BUSINESS_LOGIC);
};
